import { render, staticRenderFns } from "./DefineDataSourceForm.vue?vue&type=template&id=2c7be540&scoped=true"
import script from "./DefineDataSourceForm.vue?vue&type=script&lang=js"
export * from "./DefineDataSourceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7be540",
  null
  
)

export default component.exports